module.exports = __webpack_public_path__ + "static/Maytronics-PSQ_LockUp-b17e96f03e90dd0760a74f472a908158.png";